
export const ADD_CATEGORY = "Add_Category";
export const ADD_CATEGORY_SUCCESS = "Add_Category_success";
export const  GET_BUSNIESSCATEGORY_LIST = "get_BusniessCategory_List";
export const GET_BUSINESSCATEGORY_LIST_SUCCESS= "get_BusinessCategory_List_Success";
export const  Copy_BUSNIESSCATEGORY_LIST = "Copy_BusniessCategory_List";
export const Copy_BUSINESSCATEGORY_LIST_SUCCESS= "Copy_BusinessCategory_List_Success";
export const CHANGE_USERS_ACTIVE_PAGE="change_users_active_page";
export const SAVE_CATEGORY = "Save_Category";
export const SAVE_CATEGORY_SUCCESS = "Save_Category_success";